import { render, staticRenderFns } from "./Branche.vue?vue&type=template&id=777f27a9"
import script from "./Branche.vue?vue&type=script&lang=js"
export * from "./Branche.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports